export type LogLevel = 'debug' | 'info' | 'warn' | 'error'

export const LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
}

export interface OriginFrame {
  function?: string
  file?: string
  line?: number
}

export interface LogContext {
  serviceName?: string
  serviceVersion?: string
  sessionId?: string
  userId?: string
  origin?: OriginFrame
  [key: string]: unknown
}

export interface LogRecord {
  timestamp: string
  level: LogLevel
  scope?: string
  message: string
  context?: LogContext
  error?: unknown
}

export interface Transport {
  name: string
  write(record: LogRecord): void
}
